import * as React from "react";
import { FormHelperText } from "@mui/material";
import { Warning } from "@phosphor-icons/react/dist/ssr/Warning";

export function CustomFormHelperError({ text, color = "var(--mui-palette-error-main)" }: { text: string; color?: string }) {
	return (
		<FormHelperText sx={{ display: "flex", alignItems: "center", gap: 0.5, color: color }}>
			<Warning width={14} height={14} weight="fill" color={color} />
			{text}
		</FormHelperText>
	);
}
